// MIT License
// Copyright (c) 2012 Makina Corpus
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

import togeojson from 'togeojson';

import * as JSZip from 'jszip';

export function FileLoader (L) {
  return L.Layer.extend({
    options: {
      layer: self.L.geoJson,
      layerOptions: {},
      fileSizeLimit: 1024
    },

    initialize: function (map, options) {
      this._map = map;
      self.L.Util.setOptions(this, options);

      this._parsers = {
        geojson: this._loadGeoJSON,
        json: this._loadGeoJSON,
        gpx: this._convertToGeoJSON,
        kml: this._convertToGeoJSON,
        kmz: this._convertKMZtoGeoJSON
      };
    },

    load: function (file, ext) {
      var parser,
        reader;

      // Check file is defined
      if (this._isParameterMissing(file, 'file')) {
        throw new Error('Parameter missing');
        // return false
      }

      // Check file size
      if (!this._isFileSizeOk(file.size)) {
        throw new Error('File size exceeded');
        // return false
      }

      // Get parser for this data type
      parser = this._getParser(file.name, ext);
      if (!parser) {
        throw new Error('Not parsre');
        // return false
      }

      // Read selected file using HTML5 File API
      reader = new FileReader();
      reader.onload = self.L.Util.bind(function (e) {
        var layer;
        try {
          let that = this;
          that.fire('data:loading', { filename: file.name, format: parser.ext });
          parser.processor.call(that, e.target.result, parser.ext, function (a) {
            layer = a;
            that.fire('data:loaded', {
              layer: layer,
              filename: file.name,
              format: parser.ext
            });
          });
        } catch (err) {
          this.fire('data:error', { error: err });
        }
      }, this);
      // Testing trick: tests don't pass a real file,
      // but an object with file.testing set to true.
      // This object cannot be read by reader, just skip it.
      if (!file.testing) {
        reader.readAsBinaryString(file);
      }
      // We return this to ease testing
      return reader;
    },

    loadMultiple: function (files, ext) {
      var readers = [];
      if (files[0]) {
        files = Array.prototype.slice.apply(files);
        while (files.length > 0) {
          readers.push(this.load(files.shift(), ext));
        }
      }
      // return first reader (or false if no file),
      // which is also used for subsequent loadings
      return readers;
    },

    // loadData: function (data, name, ext) {
    //   var parser
    //   var layer

    //   // Check required parameters
    //   if ((this._isParameterMissing(data, 'data')) || (this._isParameterMissing(name, 'name'))) {
    //     return
    //   }

    //   // Check file size
    //   if (!this._isFileSizeOk(data.length)) {
    //     return
    //   }

    //   // Get parser for this data type
    //   parser = this._getParser(name, ext)
    //   if (!parser) {
    //     return
    //   }

    //   // Process data
    //   try {
    //     this.fire('data:loading', { filename: name, format: parser.ext })
    //     layer = parser.processor.call(this, data, parser.ext, function (a) {
    //       console.log('hola')
    //     })
    //     this.fire('data:loaded', {
    //       layer: layer,
    //       filename: name,
    //       format: parser.ext
    //     })
    //   } catch (err) {
    //     this.fire('data:error', { error: err })
    //   }
    // },

    _isParameterMissing: function (v, vname) {
      if (typeof v === 'undefined') {
        this.fire('data:error', {
          error: new Error('Missing parameter: ' + vname)
        });
        return true;
      }
      return false;
    },

    _getParser: function (name, ext) {
      var parser;
      ext = ext || name.split('.').pop();
      parser = this._parsers[ext];
      if (!parser) {
        this.fire('data:error', {
          error: new Error('Unsupported file type (' + ext + ')')
        });
        return undefined;
      }
      return {
        processor: parser,
        ext: ext
      };
    },

    _isFileSizeOk: function (size) {
      var fileSize = (size / 1024).toFixed(4);
      if (fileSize > this.options.fileSizeLimit) {
        this.fire('data:error', {
          error: new Error(
            'File size exceeds limit (' + fileSize + ' > ' + this.options.fileSizeLimit + 'kb)'
          )
        });
        return false;
      }
      return true;
    },

    _loadGeoJSON: function _loadGeoJSON (content) {
      var layer;
      if (typeof content === 'string') {
        content = JSON.parse(content);
      }
      layer = this.options.layer(content, this.options.layerOptions);

      if (layer.getLayers().length === 0) {
        throw new Error('GeoJSON has no valid layers.');
      }

      if (confirm('Se van a cargar un total de ' + layer.getLayers().length + ' elementos. ¿Desea continuar?')) {
        if (this.options.addToMap) {
          layer.addTo(this._map);
        }
        return layer;
      } else {
        throw new Error('Cancelando carga.');
      }
    },

    _convertToGeoJSON: function _convertToGeoJSON (content, format, cb) {
      var geojson;
      // Format is either 'gpx' or 'kml'
      if (typeof content === 'string') {
        content = (new window.DOMParser()).parseFromString(content, 'text/xml');
      }
      geojson = togeojson[format](content);
      cb(this._loadGeoJSON(geojson));
    },

    _convertKMZtoGeoJSON: function _convertKMZtoGeoJSON (content, format, cb) {
      JSZip.loadAsync(content).then((zip) => {
        let promise = null;
        promise = zip.file('doc.kml').async('string');
        promise.then((kmlContents) => {
          this._convertToGeoJSON(kmlContents, 'kml', function (contentsFile) {
            cb(contentsFile);
          });
        });
      }).catch((err) => {
        console.log('Err: ', err);
      });
    }
  });
}

export function FileLayerLoad (L) {
  return L.Control.extend({

    statics: {
      TITLE: 'Cargar archivo (KML, KMZ)',
      LABEL: '<i class="fa fa-globe"></i>'
    },
    options: {
      position: 'topleft',
      fitBounds: true,
      layerOptions: {},
      addToMap: true,
      fileSizeLimit: 1024
    },

    initialize: function (options) {
      self.L.Util.setOptions(this, options);
      this.loader = null;
    },

    onAdd: function (map) {
      this.loader = self.L.FileLayer.fileLoader(map, this.options);

      this.loader.on('data:loaded', function (e) {
        // Fit bounds after loading
        if (this.options.fitBounds) {
          // window.setTimeout(function () {
          //   map.fitBounds(e.layer.getBounds())
          // }, 500)
        }
      }, this);

      // Initialize Drag-and-drop
      this._initDragAndDrop(map);

      // Initialize map control
      return this._initContainer();
    },

    _initDragAndDrop: function (map) {
      var callbackName;
      var thisLoader = this.loader;
      var dropbox = map._container;

      var callbacks = {
        dragenter: function () {
          map.scrollWheelZoom.disable();
        },
        dragleave: function () {
          map.scrollWheelZoom.enable();
        },
        dragover: function (e) {
          e.stopPropagation();
          e.preventDefault();
        },
        drop: function (e) {
          e.stopPropagation();
          e.preventDefault();

          thisLoader.loadMultiple(e.dataTransfer.files);
          map.scrollWheelZoom.enable();
        }
      };
      for (callbackName in callbacks) {
        if (callbacks.hasOwnProperty(callbackName)) {
          dropbox.addEventListener(callbackName, callbacks[callbackName], false);
        }
      }
    },

    _initContainer: function () {
      var thisLoader = this.loader;

      // Create a button, and bind click on hidden file input
      var fileInput;
      var zoomName = 'leaflet-control-filelayer leaflet-control-zoom';
      var barName = 'leaflet-bar';
      var partName = barName + '-part';
      var container = self.L.DomUtil.create('div', zoomName + ' ' + barName);
      var link = self.L.DomUtil.create('a', zoomName + '-in ' + partName, container);
      link.innerHTML = self.L.Control.FileLayerLoad.LABEL;
      link.href = '#';
      link.title = self.L.Control.FileLayerLoad.TITLE;

      // Create an invisible file input
      fileInput = self.L.DomUtil.create('input', 'hidden', container);
      fileInput.type = 'file';
      fileInput.multiple = 'multiple';
      if (!this.options.formats) {
        fileInput.accept = '.gpx,.kml,.json,.geojson,.kmz';
      } else {
        fileInput.accept = this.options.formats.join(',');
      }
      fileInput.style.display = 'none';
      // Load on file change
      fileInput.addEventListener('change', function () {
        thisLoader.loadMultiple(this.files);
        // reset so that the user can upload the same file again if they want to
        this.value = '';
      }, false);

      self.L.DomEvent.disableClickPropagation(link);
      self.L.DomEvent.on(link, 'click', function (e) {
        fileInput.click();
        e.preventDefault();
      });

      return container;
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/Modules/Map/FileLoader.js